import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DetailPropertyGroup } from '../objects/DetailObject';
import { DetailService } from '../services/detail.service';
import { InfoCard } from '../objects/DetailObject'
@Component({
  selector: 'app-cardinfo',
  templateUrl: './cardinfo.component.html',
  styleUrls: ['./cardinfo.component.css']
})
export class CardinfoComponent implements OnInit, OnChanges {

@Input() private infoCardName :string;
@Input() private detailCardId :string;
private componentId:string;
infoCard:InfoCard;
private left = "left";

  constructor(private detailService:DetailService) { }

  createInfoCard(){
    this.detailService.createInfoCard(this.detailCardId, this.infoCardName).subscribe(result=>{
      this.componentId = result;
      this.getInfoCard();
    });
  }

  getInfoCard(){
    if(this.componentId){
      this.detailService.getInfoCard(this.componentId).subscribe(result=>{
        this.infoCard = JSON.parse(result);
      });
    }
  }

  ngOnInit() {
  }

  ngOnChanges(changes:SimpleChanges){
    if(this.componentId){
      this.getInfoCard();
    }else{
      this.createInfoCard();
    }
  }
}
